
/// <reference path="./d/app.d.ts" />

var paymentPanelHandler = {

	$cnt: null,

	init: function(data)
	{
		this.data = data;
		this.$cnt = $("#paymentPanel");
		this.$cnt.find("li.type").click($.proxy(function(e) {
			var $item = $(e.currentTarget);
			debug.log($item);
			this.show($item.data("type"));
		}, this));

		this.$cnt.find("input[type=radio]").change($.proxy(function(e) {
			var $item = $(e.currentTarget);
			this.updatePanel($item.closest("form").data("type"), $item.val());
		}, this));

		this.$cnt.find("a.x").click($.proxy(function(e) {this.close(); return false;}, this));

		this.$cnt.find(".panel-alternative .button").click($.proxy(function() {
			this.$cnt.find(".panel-alternative form").submit();
		}, this));

		this.$cnt.find(".panel-cryptocurrency .button").click($.proxy(function() {
			this.$cnt.find(".panel-cryptocurrency form").submit();
		}, this));

	},

	show: function(type, amount)
	{
		debug.log("paymentPanelHandler::show", type, amount);

		var $panels = this.$cnt.find(".panel");
		var $panel = $panels.filter(".panel-" + type);
		var $lis = this.$cnt.find("li.type");
		var $li = $lis.filter(".type-" + type);
		var $radios = $panel.find("input[type=radio]");
		if ($li.hasClass("disabled")) return;

		scrollPanelHandler.setVisible(false, true);
		this.$cnt.show();
		$panels.hide();
		$panel.show();
		$lis.removeClass("active");
		$li.addClass("active");

		if (parseInt(amount,10)) {
			$radios.removeAttr("checked");
			//$radios.filter("[value=" + amount + "]").attr("checked", "checked");
			$radios.filter("[value=" + amount + "]").prop("checked", true);
		} else {
			var selectedAmount = $panel.find("input[type=radio]:checked").val();
			if (!selectedAmount) {
				$radios.removeAttr("checked");
				var first = $radios.filter(":eq(0)");
				//first.attr("checked", "checked");
				first.prop('checked', true);
				amount = first.val();
			} else {
				amount = selectedAmount;
			}
		}

		this.updatePanel(type, amount);
	},

	close: function()
	{
		this.$cnt.hide();
	},

	updatePanel: function(type, id)
	{
		debug.log("[paymentPanelHandler::updatePanel]", type, id, entry);
		var typeParams = this.data.topupTypes[type];
		var entry = typeParams.entries[id];

		switch (type)
		{
			case "sms_hu":
			case "phone_hu":

				var $panel = this.$cnt.find(".panel-" + type + " .content");
				var phoneNo = entry.phone.replace(/^(\d{2})(\d{2})(\d{3})(\d{3,4})$/, '$1 $2 $3 $4');

				$panel.find('.amount').text(creditCalculator.calc(id));
				$panel.find('.price').text(entry.price);
				$panel.find('.netprice').text(Math.floor(entry.price / 1.27));

				if (type === 'sms_hu') {
					$panel.find('.code').text(typeParams.code);
				} else {
					$.getJSON('/callback', {command: 'getUserPhoneCode', credit: id}, function (r) {
						if (r && r.success) $panel.find('.code').text(r.code);
					});
				}
				$panel.find(".phone").text(phoneNo);
				break;
		}
	}
};

var fakeSP = {
	init: () => {
		this.$bar = $(".float-bar");
		this.$bar.show();

		this.$tab = this.$bar.find(".float-bar-tab");
		this.$wrapper = this.$bar.find(".content-wrapper");
		this.$panels = this.$wrapper.find(".content");

		this.$wrapper
			.removeClass("opening opened closing closed")
			.addClass("closed");

		this.$tab.find(".open").show();
		this.$tab.find(".close").hide();

		this.$tab.on("click", () =>
		{
			$('html, body').animate({ scrollTop: 0 });
			topupHandler.show("", "creditcard", 5000);
		});

		var $panel = this.$panels.filter(".creditcard");

		var title = $panel.data("title");
		if (title) this.$tab.find(".tab-title").text(title);

	}
};

var topupHandler =
{
	data: null,
	promo: {},
	minAmount: {},

	init: function(data : any)
	{
		paymentPanelHandler.init(data);
		this.update(data);
		if (this.data.topupTypes.creditcard && this.data.topupTypes.creditcard.provider === "epoch")
		{
			fakeSP.init();
		}
	},

	update: function(data)
	{
		this.data = data;
		this.updateDropDown(data);
	},

	updateDropDown: function()
	{
		const topupTypes = this.data.topupTypes;
		const currencies = this.data.currencies;
		const $dropdown = $(".userMenu .icon.credit ul");

		if(this.data.topupCount == 0) {
			$('.type-phone_hu').hide();
			$('.type-cryptocurrency').hide();
			$('.type-alternative').hide();
		}

		$dropdown.empty();

		Object.keys(topupTypes).forEach((type) =>
		{
			if(this.data.topupCount == 0) {
				if(type != 'creditcard' && type != 'sms_hu') { return; }
			}

			const name = topupTypes[type].name;
			const entryType = type === "alternative" ? "altEntries" : "entries";
			const entries = topupTypes[type][entryType];
			const $li = $("<li class=\"group\" />")
				.addClass("group-" + type)
				.text(name)
				.appendTo($dropdown);

			//if (type === "cryptocurrency")
			//{
			//	$li.addClass("new");
			//	$li.append(
			//		$("<span class='new' />")
			//			.text($dropdown.attr("data-new"))
			//	);
			//}

			Object.keys(entries).forEach((idstr) =>
			{
				var fValue, fPrice, fPrevPrice, fPrevCredits, $item, linkText, discountPrice;
				var id = parseInt(idstr, 10);

				if (entryType == "entries")
				{
					if (type in this.minAmount && this.minAmount[type] && id < this.minAmount[type]) {
						return true;
					}

					var promoType = (type in this.promo) && this.promo[type]
						? this.promo[type].type
						: null;

					switch (promoType)
					{
						case "discount":
							discountPrice = this.promo[type].getAmount(id);

							fValue = currencies.cre.template.replace("{{value}}", creditCalculator.calc(id));

							fPrice = currencies[entries[id].currency].template
								.replace("{{intvalue}}", Math.round(discountPrice))
								.replace("{{value}}", discountPrice.toFixed(2));

							fPrevPrice = currencies[entries[id].currency].template
								.replace("{{intvalue}}", Math.round(entries[id].price))
								.replace("{{value}}", entries[id].price.toFixed(2));

							linkText = fValue + " <s class=\"diagonal\">(" + fPrevPrice + ")</s> " + fPrice;

							break;

						case "extraCredit":

							var extra = this.promo[type].getAmount(id);
							if (extra === Object(extra)) {
								if (id in extra) extra = extra[id];
								else {
									debug.error("Extra credits are not defined for amount", id);
									extra = 0;
								}
							}

							fValue = currencies.cre.template.replace(
								"{{value}}",
								creditCalculator.calc(id) + " + " +
								creditCalculator.calc(extra)
							);

							fPrice = currencies[entries[id].currency].template
								.replace("{{intvalue}}", Math.round(entries[id].price))
								.replace("{{value}}", entries[id].price.toFixed(2));

							linkText = fValue + " (" + fPrice + ")";
							break;

						default:
							fValue = currencies.cre.template.replace("{{value}}", creditCalculator.calc(id));

							fPrice = currencies[entries[id].currency].template
								.replace("{{intvalue}}", Math.round(entries[id].price))
								.replace("{{value}}", entries[id].price.toFixed(2));

							if (entries[id].previousPrice) {
								fPrevPrice = currencies[entries[id].currency].template
									.replace("{{intvalue}}", Math.round(entries[id].previousPrice))
									.replace("{{value}}", entries[id].previousPrice.toFixed(2));
								linkText = fValue + " <s class=\"diagonal\">(" + fPrevPrice + ")</s> " + fPrice;
							} else if (entries[id].previousCredits) {
								fPrevCredits = currencies["cre"].template
									.replace("{{intvalue}}", Math.round(entries[id].previousCredits))
									.replace("{{value}}", entries[id].previousCredits);
								linkText = "(<s class=\"diagonal\" style='margin: 0;'>" + fPrevCredits + "</s>) " + fValue + " (" + fPrice + ")";
							} else {
								linkText = fValue + " (" + fPrice + ")";
							}
					}

				} else {
					linkText = entries[idstr];
				}

				$item = $("<li />").appendTo($dropdown);

				//if (type === "cryptocurrency")
				//{
				//	$item.addClass("new");
				//}

				$("<a href='#' />")
					.click(topupHandler.show.bind(topupHandler, "header", type, id))
					.append(linkText)
					.appendTo($item);
			})
		});
	},

	initEcPromo: function(name, promo)
	{
		this.promo[name] = promo;
		this.updateDropDown();
	},

	initDiscountPromo: function(name, promo)
	{
		this.promo[name] = promo;
		this.updateDropDown();
	},

	clearPromo: function(name)
	{
		delete this.promo[name];
		this.updateDropDown();
	},

	show: function(source, type, credit, e = null)
	{
		debug.log('[topupHandler::show]', source, type, credit, e);

		switch (type)
		{
			case 'creditcard':
				if (this.data.topupTypes[type].provider === 'epoch') {
					paymentPanelHandler.show("alternative", credit);
				} else if (this.data.topupTypes[type].provider == 'securionpay') {
					securionPayHandler.showTopup(credit);
				}
				break;

			default:
				paymentPanelHandler.show(type, credit);
				break;
		}

		if (type !== "creditcard" || this.data.topupTypes[type].provider !== "securionpay")
		{
			// Close the securionpay panel (only the purchase panels) if user chooses other payment method
			securionPayHandler.panel.close("quickbuy");
			securionPayHandler.panel.close("creditcard");
		}

		if (e && "preventDefault" in e) e.preventDefault();
	}
};

class MemberIncentive
{
	private $root : JQuery;
	private frame : Sxc.WindowManager.Frame;

	private mode : string;

	private topupHandler : Function;
	private closeHandler : Function;

	constructor(triggers = null)
	{
		this.frame = new Sxc.WindowManager.Frame("memberincentive");
		this.$root = $($("#memberincentiveTemplate").html());
		this.frame.setContent(this.$root);

		this.$root.filter(".close").click(() => {
			this.hide();
		});

		this.$root.find(".topup-button").click(() => {
			this.topupHandler();
			this.hide();
		});

		this.$root.find(".topup-icon").click(() => {
			this.topupHandler();
			this.hide();
		});

		this.$root.find(".cc").click(() =>
		{
			if (this.mode == "strict")
			{
				topupHandler.show("", "creditcard", null);
				securionPayHandler.onNextSuccess = () => {
					this.frame.onHide(() => {});
					this.hide();
				}
			}
			else
			{
				this.hide();
			}
		});

		//this.$root.find(".alt").click(() => {
		//	topupHandler.show("", "alternative", null);
		//	$("#pageScrollContainer").scrollTop($("#paymentPanel").offset().top - 20);
		//	$("#paymentPanel").css({
		//		"z-index": 150,
		//		"position": "relative"
		//	});
		//});
	}

	setTopupIconPos(left, top) {
		debug.log("setTopupIconPos", left, top);
		this.$root.filter(".topup-icon-wrapper").css({left: Math.round(left) + 15, top: Math.round(top) + 136})
	}

	show(mode, screenName, topupHandler, closeHandler)
	{
		this.mode = mode;
		this.topupHandler = topupHandler;
		this.closeHandler = closeHandler;

		let template = Math.floor(Math.random() * 3) + 1;

		this.$root.addClass("template-" + template);
		this.$root.removeClass("mode-warn mode-strict");
		this.$root.addClass("mode-" + mode);

		this.$root.find(".content").hide();
		this.$root.find(".content." + mode).show();

		this.$root.find(".screenname").text(screenName);

		window.scroll(0, 0);
		$(document).on("mousewheel.mivipwheel", (e) => {
			e.preventDefault();
		});

		let keys = [33,34,35,36,37,38,39,40];
		$(document).on("keydown.mivipwheel", (e) => {
			let key = e.which;
			if($.inArray(key,keys) > -1) {
				e.preventDefault();
				return false;
			}
			return true;
		});

		$(document).on("keydown.mivipesc", (e) => {
			let key = e.which;
			if(key == 27) {
				e.preventDefault();
				e.stopPropagation();
				this.hide();
				return false;
			}
			return true;
		});

		this.frame.show();

		this.frame.onHide(() => {
			$(document).off("keydown.mivipesc");
			$(document).off("keydown.mivipwheel");
			$(document).off("mousewheel.mivipwheel");
			if (this.closeHandler) this.closeHandler();
		});
	}

	hide()
	{
		this.frame.hide();
	}
}
